var PageEntryPoint =
webpackJsonpPageEntryPoint([16],{

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "7Iys":
/***/ (function(module, exports, __webpack_require__) {

var jade = __webpack_require__("TBTh");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (isLoggedIn) {
var linkId = (isLoggedIn === true) ? 'navbar-logout-link' : 'navbar-login-link'
var linkClass = (isLoggedIn === true) ? 'webchat-myvhi-logout' : 'webchat-myvhi-login'
var btnText = (isLoggedIn === true) ? 'common:header.logout' : 'common:header.login'
var url =  (isLoggedIn === true) ? "javascript:window.location.href='logout';" : '/myvhi'
buf.push("<a" + (jade.attr("id", '' + (linkId) + '', true, true)) + (jade.attr("href", '' + (url) + '', true, true)) + (jade.cls(['navbar-login-link ' + (linkClass) + ''], [true])) + "><button id=\"navbar-login-btn\"" + (jade.attr("data-i18n", "" + (btnText) + "", true, true)) + " class=\"navbar-login-btn\">Log out</button></a>");}.call(this,"isLoggedIn" in locals_for_with?locals_for_with.isLoggedIn:typeof isLoggedIn!=="undefined"?isLoggedIn:undefined));;return buf.join("");
}

/***/ }),

/***/ "CCE4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("7t+N");
var urls = __webpack_require__("g+w9");

var ajaxStatusConfig = {
    STATUS_GONE: 410,
    UNPROCESSABLE: 422,
	NOT_IMPLEMENTED: 501
};

function ajaxGetJson(config){
	return $.ajax({
					url : config.url,
					dataType: 'json',
					contentType: 'application/json; charset=utf-8',
					headers: config.headers,
					data: getJsonString(config),
					async	: getAsync(config),
					type : 'GET'
			});
}

function ajaxPostJson(config) {
	return $.ajax({
		url : config.url,
		dataType: 'json',
		contentType: 'application/json; charset=utf-8',
		headers: getHeaders(config),
		data: getJsonString(config),
		async	: getAsync(config),
		type : 'POST',
		timeout: config.timeout
	});
}

function getJsonString(config){
	return (typeof config.jsonString !== 'undefined') ? config.jsonString : '';
}

function getAsync(config) {
	if (typeof config.async === 'undefined') {
		return true;
	} else {
		return config.async;
	}
}

function getHeaders(config){
	return (typeof config.headers !== 'undefined') ? config.headers : '';
}

/**
 * Helper method to be used in .fail() handler of jquery AJAX requests
 * Provides generic failure handling and ability to ignore certain codes
 * @param message
 * @param ignoreCodes - optional array of numbers for status codes for which error handling won't be invoked
 * @returns {Function}
 */
function handleError(message, ignoreCodes) {
    return function (jqXHR, status, faf) {
        if (ignoreCodes && ignoreCodes.indexOf(jqXHR.status) > -1) {
            console.log('Skipping processing of error code ' + jqXHR.status);
        } else {
            errorHandler(jqXHR, message);
        }
    };
}

/**
 * Jquery ajax error handler
 */
function errorHandler(jqXHR, message) {
    console.error('ajaxHandler.errorHandler '+jqXHR.status+' '+ message);
    if (jqXHR.status === ajaxStatusConfig.UNPROCESSABLE) {
        return;
    }

    if (jqXHR.status === ajaxStatusConfig.STATUS_GONE) {
        urls.navigateToUrl("/groups"+'/session-expired');
        return;
    }

    if (jqXHR.status === ajaxStatusConfig.NOT_IMPLEMENTED) {
        urls.navigateToUrl("/groups"+'/not-supported');
        return;
    }
	urls.navigateToUrl("/groups"+'/internal-problem');

}

module.exports = {
	ajaxGetJson : ajaxGetJson,
	ajaxPostJson: ajaxPostJson,
    handleError: handleError,
	errorHandler: errorHandler,
};



/***/ }),

/***/ "JOWb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = __webpack_require__("Eb2/").namespace('groups');


/***/ }),

/***/ "RVtR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by c_razmuss_a on 12/10/2017.
 */


var $ = __webpack_require__("7t+N");
__webpack_require__("gNGx");
var positioning = __webpack_require__("KFdh");
var groupSchemeService = __webpack_require__("pHlT");
var header = __webpack_require__("iPHx");
var footer = __webpack_require__("rqn6");
var loginStatusService = __webpack_require__("Ytzv");

function init(isLoginLogoutCta) {
    // Show/hide logout CTA
    var headerCb = (isLoginLogoutCta === true) ? header.initWithLoginCta : header.init;
    var loggedInPromise = loginStatusService.getIsUserLoggedIn();
    loggedInPromise.done(function(isLoggedIn) {
        headerCb(isLoggedIn, true);
    });

    var contactInfoPromise = groupSchemeService.getContactInformation();
    contactInfoPromise.done(footer.init);

    positioning.sameHeightConfig.minWidth = 0;
    positioning.registerSameHeightListener();

    return $.when(contactInfoPromise, loggedInPromise);
}

module.exports.init = init;


/***/ }),

/***/ "Ytzv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__("7t+N");

function getIsUserLoggedIn(){
    var userLoggedInPromise = $.Deferred();
    $.get( "/groups" + '/rest/accessManagement/loginStatus')
        .done(function (data) {
                console.log("getIsUserLoggedIn : " + data);
                if(data.loggedIn===true){
                    userLoggedInPromise.resolve(true);
                }else{
                    userLoggedInPromise.resolve(false);
                }
        })
        .fail(function(jqXHR, textStatus, error) {
            console.log( "error: status = %s", jqXHR.status);
            console.log( "error: responseText = %s", jqXHR.responseText);
            console.log( "error: textStatus = %s", textStatus);
            console.log( "error: error = %s", error);
            userLoggedInPromise.resolve(false);
        });

    return userLoggedInPromise.promise();
}

module.exports.getIsUserLoggedIn = getIsUserLoggedIn;

/***/ }),

/***/ "bsvw":
/***/ (function(module, exports, __webpack_require__) {

var usualPageSetup = __webpack_require__("RVtR");

function init() {
    'use strict';
    usualPageSetup.init();
}

module.exports.init = init;


/***/ }),

/***/ "g+w9":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
    'use strict';

    var testUrlParameters;

    function getAllUrlParameters() {
        if (testUrlParameters) {
            return testUrlParameters;
        }
        return window.location.search.substring(1);
    }

    function getUrlPath() {
        return window.location.pathname;
    }

    function redirectToUrl(destinationUrl) {
        window.location.replace(destinationUrl);
    }

    function navigateToUrl(destinationUrl) {
        window.location.href = destinationUrl;
    }

    return {
        getUrlParameter: function (paramName) {
            var params = getAllUrlParameters();
            console.log(params);
            var paramList = params.split('&');

            for (var i = 0; i < paramList.length; i++) {
                var param = paramList[i].split('=');
                if (param[0] === paramName) {
                    return param[1];
                }
            }
        },
        getAllUrlParameters: getAllUrlParameters,
        setTestUrlParameters: function (urlParameters) {
            testUrlParameters = urlParameters;
        },
        redirectToUrl: redirectToUrl,
        navigateToUrl: navigateToUrl,
        getUrlPath: getUrlPath
    };
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "iPHx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("7t+N");
var stickyHeader = __webpack_require__("j7WF");

/**
 * Initialises the header state.
 * <p>
 * Takes a promise as argument that return true/false.
 * If the promise resolves to true, the log out CTA is displayed.
 * For all other resolution states the log out CTA in NOT displayed.
 * </p>
 */
function init(isLoggedIn) {
    stickyHeader.apply('nav-bar-top', 'page-container', false);
    showHideLogoutCTA(isLoggedIn);
}

function initWithLoginCta(isLoggedIn, isGroups) {
    stickyHeader.apply('nav-bar-top', 'page-container', false);

    if (isGroups || (!isGroups && isLoggedIn)) {
        var loginButtonTemplate = __webpack_require__("7Iys");
        var html = loginButtonTemplate({isLoggedIn: isLoggedIn});
        var $placeHolder = $('#login-btn-dynamic-content');
        $placeHolder.html(html);
    }
}

/**
 * Displays or hides the Logout CTA.
 * @param aBoolean if true the Logout CTA is displayed, remains hidden otherwise.
 */
function showHideLogoutCTA(aBoolean){
    if(aBoolean===true){
        $('#nav-logout').show();
    }else{
        $('#nav-logout').hide();
    }
}

module.exports = {
    init: init,
    initWithLoginCta: initWithLoginCta
};

/***/ }),

/***/ "pHlT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * This service provides session group scheme information, including basic contact information
 * uses session storage to cache groupScheme information
 * if request has been initiated and not yet resolved any new requests will return the promise of the first request
 * @author c_razmuss_a (Arturs Razmuss) on 16/02/2018
 */
var $ = __webpack_require__("7t+N");
var ajaxHandler = __webpack_require__("CCE4");
var store = __webpack_require__("JOWb");

//const
var cacheKey = 'groupSchemeBasicInfo';
/**
 * as the group scheme data are related to session there is no need to have multiple concurrent requests
 */
var fetchInProgress;

function getGroupScheme(refresh, groupSchemeToken) {
    if (refresh !== true && store.session.has(cacheKey)) {
        return $.Deferred().resolve(store.session.get(cacheKey)).promise();
    } else {
        return fetchGroupScheme(groupSchemeToken);
    }
}

function getContactInformation(refresh) {
    if (refresh !== true && store.session.has(cacheKey)) {
        return $.Deferred().resolve(store.session.get(cacheKey).vhiContacts[0]).promise();
    } else {
        return fetchGroupScheme()
            .then(function(groupSchemeBasicInfo) {
                return groupSchemeBasicInfo.vhiContacts[0];
            });
    }
}

function fetchGroupScheme(groupSchemeToken) {
    if (fetchInProgress) {
        return fetchInProgress;
    } else {
        // The case when user hasn't visited "/groups" page before "/myvhi" and there is no GroupScheme info in session
        // (can be called when displaying custom enrolment content)
        if(groupSchemeToken) {
            fetchInProgress = ajaxHandler.ajaxGetJson({url: '/groups/rest/schemeByToken', jsonString: {'token': groupSchemeToken} })
                .then(onSuccess)
                .always(onAlways);
        } else {
            fetchInProgress = ajaxHandler.ajaxGetJson({ url: '/groups/rest/scheme'})
                .then(onSuccess)
                .always(onAlways);
        }
        return fetchInProgress;
    }
    
    function onSuccess(groupSchemeBasicInfo) {
        store.session(cacheKey, groupSchemeBasicInfo);
        return groupSchemeBasicInfo;
    }

    function onAlways() {
        fetchInProgress = null;
    }
}

module.exports.getGroupScheme = getGroupScheme;
module.exports.getContactInformation = getContactInformation;


/***/ })

},["bsvw"]);


// WEBPACK FOOTER //
// /default.js